<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1">
            <b-button block variant="info">Origem</b-button>
          </b-card-header>
          <b-card-body>
            <b-form-select v-model="typeorig" :options="types"> </b-form-select>
            <b-form-textarea rows="10" v-model="textorig"></b-form-textarea>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1">
            <b-button block variant="info">Destino</b-button>
          </b-card-header>
          <b-card-body>
            <b-form-select
              v-model="typedest"
              :options="typesdest"
            ></b-form-select>
            <json-viewer
              v-if="typedest == 'ObjectJson'"
              :value="ObjectJsonParsed"
              :expand-depth="5"
              copyable
              boxed
              sort
            ></json-viewer>
            <div v-if="typedest == 'html'" class="border rounded">
              <div v-html="ObjectJsonParsed" class="m-4"></div>
            </div>
            <b-form-textarea
              v-if="!['ObjectJson', 'html'].find((t) => t == typedest)"
              rows="10"
              v-model="textdest"
            ></b-form-textarea>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button block variant="info" @click="convert">Convert</b-button>
      </b-col>
    </b-row>
    <!--
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="info">Origem</b-button>
      </b-card-header>
      <b-collapse
        id="accordion-1"
        visible
        role="tabpanel"
        v-model="collapseorig"
        >
        <b-card-body>
          <b-form-select v-model="typeorig" :options="types"> </b-form-select>
          <b-form-textarea rows="10" v-model="textorig"></b-form-textarea>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info">Destino</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" role="tabpanel" v-model="collapsedest">
        <b-card-body>
          <b-form-select
          v-model="typedest"
          :options="typesdest"
          ></b-form-select>
          <json-viewer
          v-if="typedest == 'ObjectJson'"
          :value="ObjectJsonParsed"
            :expand-depth="5"
            copyable
            boxed
            sort
          ></json-viewer>
          <div v-if="typedest == 'html'" class="border rounded">
            <div v-html="ObjectJsonParsed" class="m-4"></div>
          </div>
          <b-form-textarea
            v-if="!['ObjectJson', 'html'].find((t) => t == typedest)"
            rows="10"
            v-model="textdest"
          ></b-form-textarea>
        </b-card-body>
      </b-collapse>
    </b-card>
    -->
  </div>
</template>

<script>
export default {
  name: "Translate",

  data() {
    return {
      types: ["json", "ObjectJson", "Token", "jwt", "html", "base64", "text"],
      typeorig: "json",
      typedest: "text",
      textdest: "",
      textorig: "",
      collapseorig: true,
      collapsedest: false,
    };
  },

  computed: {
    typesdest() {
      return this.types.filter((f) => f !== this.typeorig);
    },
    vtextorig() {
      switch (this.typeorig) {
        case "json": {
          try {
            JSON.parse(this.textorig);
            return true;
          } catch {
            return false;
          }
        }
        case "jwt": {
          return this.textorig.split(".").length == 3;
        }
        case "html": {
          return this.isHTMLValid(this.textorig);
        }
        case "base64": {
          try {
            btoa(this.textorig);
            return true;
          } catch {
            return false;
          }
        }
        default:
          return true;
      }
    },

    ObjectJsonParsed() {
      if (this.vtextorig) {
        return JSON.parse(this.textdest);
      } else {
        return {};
      }
    },
  },

  methods: {
    convert() {
      const tipo = this.typeorig + "." + this.typedest;

      if (this.vtextorig) {
        switch (tipo) {
          case "text.ObjectJson": {
            this.textdest = JSON.parse(this.textorig);
          }
          case "json.ObjectJson": {
            this.textdest = JSON.parse(this.textorig);
          }
          case "json.text": {
            this.textdest = JSON.stringify(this.textorig);
          }
          case "html.html": {
            this.textdest = this.textorig;
          }
          case "html.text": {
            this.textdest = this.textorig;
          }
          case "text.base64": {
            this.textdest = btoa(this.textorig);
          }
          case "base64.text": {
            this.textdest = atob(this.textorig);
          }
          case "jwt.text": {
            this.textdest = {
              header: JSON.parse(
                decodeURIComponent(
                  atob(
                    this.textorig
                      .split(".")[0]
                      .replace(/-/g, "+")
                      .replace(/_/g, "/")
                  )
                )
              ),
              payload: JSON.parse(
                decodeURIComponent(
                  atob(
                    this.textorig
                      .split(".")[1]
                      .replace(/-/g, "+")
                      .replace(/_/g, "/")
                  )
                )
              ),
            };
          }
          default:
            return {};
        }
      } else {
        return {};
      }
    },

    isHTMLValid(htmlString) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlString;

      // Verifica se ocorreram erros de análise e renderização
      return tempElement.innerHTML == htmlString && htmlString !== "";
    },
  },

  watch: {
    Xtextorig() {
      this.textdest = "";
      if (this.vtextorig) {
        switch (this.typeorig) {
          case "json": {
            this.textdest = this.textorig.replaceAll('"', "");
            break;
          }
        }
        this.collapseorig = false;
        this.collapsedest = true;
      }
    },
  },
};
</script>